export const PRODUCT_NAME = 'Transporeon Visibility';
